export default __webpack_public_path__ + "static/media/icon-employee-confirmation.cabbab2c.svg";